import { render, staticRenderFns } from "./BorrowableBlockList.vue?vue&type=template&id=163388ac"
import script from "./BorrowableBlockList.vue?vue&type=script&lang=js"
export * from "./BorrowableBlockList.vue?vue&type=script&lang=js"
import style0 from "./BorrowableBlockList.vue?vue&type=style&index=0&id=163388ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports